import React from "react";
import { EuiLink } from "@elastic/eui";
import AbstractColumnActions from "../../shared/entity/TableColumnAction";

// EuiTable format
const columns = (actions) => [
    {
        field: "id",
        name: "ID",
        render: (item) => (
            <span>
                <EuiLink>#{item}</EuiLink>
            </span>
        ),
        sortable: true,
        width: 70,
    },
    {
        field: "name",
        name: "Name",
        sortable: true,
        render: (item) => <b>{item}</b>,
        mobileOptions: {
            render: (item) => <b>{item.name}</b>,
            header: false,
            truncateText: false,
            enlarge: true,
            fullWidth: true,
        },
    },
    {
        field: "batteryLevel",
        name: "Battery Level",
        dataType: "string",
        sortable: true,
    },
    {
        field: "deviceModelName",
        name: "Device Model Name",
        dataType: "string",
        sortable: true,
    },
    {
        field: "imei",
        name: "IMEI",
        dataType: "string",
        sortable: true,
    },
    {
        field: "manufacturer",
        name: "Manufacturer",
        dataType: "string",
        sortable: true,
    },
    {
        field: "serialNumber",
        name: "Serial Number",
        dataType: "string",
        sortable: true,
    },
    {
        field: "mdmId",
        name: "MDM ID",
        dataType: "string",
        sortable: true,
    },
    {
        field: "lastContactTime",
        name: "Last Contact Time",
        dataType: "date",
        sortable: true,
    },
    {
        field: "lastScanTime",
        name: "Last Scan Time",
        dataType: "date",
        sortable: true,
    },
    {
        field: "addedTime",
        name: "Adding Date",
        dataType: "date",
        sortable: true,
    },
    {
        name: "Actions",
        isActionsPopover: true,
        actions: AbstractColumnActions(actions),
    },
];

export default columns;
